import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ICardEvent } from '../../models';

@Component({
  selector: 'lib-card-deck',
  styleUrls: ['card-deck.component.scss'],
  templateUrl: 'card-deck.component.html',
})
export class CardDeckComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() hasSidebar: boolean = true;
  @Input() items: any[] = [];
  @Input() titleKey: string;
  @Input() subtitleKey: string;
  @Input() descriptionKey: string;
  @Input() bodyTemplate: any;
  @Input() footerTemplate: any;
  @Input() showFooterArrow = true;
  @Input() headerClass: any;
  @Output() cardClicked = new EventEmitter<ICardEvent>();

  hasMultipleBodyItems(description: string): boolean {
    return this.bodyItems(description)?.length > 1;
  }

  selectCard($event: MouseEvent, item: any) {
    this.cardClicked.emit({ $event, data: item });
  }

  bodyItems(description: string): string[] {
    if (!description) {
      return [];
    }
    return description.split(';').map((x) => x.trim());
  }
}
